export default "__VITE_ASSET__15116928__"